import React from "react";
import styled from 'styled-components'

const CenteredLoader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
//   background-color: rgba(0, 0, 0, 0.3);
  z-index: 999;
`;

const Loader = () => {
  return (
//     <div className="flex justify-center">
//   <div className="w-10 h-10 border-4 border-blue-500 border-dotted rounded-full animate-spin" />
// </div>






    <div className="absolute inset-0 flex items-center justify-center z-20">
      <div className="w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin" />
    </div>
    // <div className="flex items-center justify-center h-full w-full bg-gray-900 bg-opacity-50 fixed top-0 left-0 z-50">
    //   <div className="w-16 h-16 border-4 border-blue-500 border-t-transparent rounded-full animate-spin" />
    // </div>
    // <CenteredLoader>
    //   <div class="spinner-border text-primary" role="status">
    //     <span class="visually-hidden"></span>
    //   </div>
    // </CenteredLoader>
  );
};

export default Loader;
